import Pet from '@spike/pet-model';
import clsx from 'clsx';
import React from 'react';
import { BelongingsTabContent } from './BelongingsTabContent';
import styles from './OrderDetailBelongingsTab.module.scss';

interface OrderDetailBelongingsTabProps {
    pets: Array<Pet>;
    selectedPet?: Pet;
    onSelectedPetChange: (pet: Pet) => void;
    className?: string;
    readOnly?: boolean;
    bookingId?: number;
    onSaved?: () => void;
}

export const OrderDetailBelongingsTab: React.FC<OrderDetailBelongingsTabProps> = ({
    pets,
    selectedPet,
    onSelectedPetChange,
    className,
    readOnly,
    bookingId,
    onSaved
}) => {
    const activePet = selectedPet ?? pets[0];

    if (!activePet) {
        return null;
    }

    return (
        <div className={clsx(styles.root, className)}>
            <BelongingsTabContent
                pets={pets}
                activePet={activePet}
                onSelectedPetChange={onSelectedPetChange}
                bookingId={bookingId}
                readOnly={readOnly}
                onSaved={onSaved}
            />
        </div>
    );
};

export default OrderDetailBelongingsTab;
